import { LabelValue } from 'app/models/labelvalue';

// TP-10136: Tripod rejects self-tours that start after the zone window end, so the HRA stops
// offering times in the last 30 minutes of the window to leave prospects a grace period.
const SELF_TOUR_END_BUFFER_MINUTES = 30;
const SELF_TOUR_SLOT_MINUTES = 30;

export function buildSelfTourTimes(
  startHour: number,
  startMinute: number,
  endHour: number,
  endMinute: number): LabelValue[] {

  const times: LabelValue[] = [];

  const earliest = new Date();
  earliest.setHours(startHour, startMinute, 0, 0);

  const latest = new Date();
  latest.setHours(endHour, endMinute, 0, 0);
  latest.setMinutes(latest.getMinutes() - SELF_TOUR_END_BUFFER_MINUTES);

  while (earliest <= latest) {
    const label = earliest.toLocaleString('en-US', {hour: '2-digit', minute: '2-digit'});
    const hours = earliest.getHours().toString().padStart(2, '0');
    const minutes = earliest.getMinutes().toString().padStart(2, '0');
    times.push({label: label, value: `${hours}:${minutes}`});
    earliest.setMinutes(earliest.getMinutes() + SELF_TOUR_SLOT_MINUTES);
  }
  return times;
}
